





























































































import Vue from 'vue';
// import * as firebase from '@/plugins/firebase';
// import exhibitor, { Exhibitor } from '@/modules/exhibitor/exhibitor';
// /// import  { Exhibitor } from '@/modules/exhibitor/exhibitor';
// import company, { Company } from '@/modules/exhibitor/company';
import {
  calender,
  Exhibitor,
  exhibitor,
  ExhibitorCompany as Company,
  exhibitorCompany as company,
} from 'mostra';
import { v4 } from 'uuid';

// import { FirebaseID } from '@/modules/firebase';

interface ExhibitorInfo {
  exhibitor: Exhibitor;
  account: {
    email: string;
    password: string;
  };
}

interface DataType {
  exhibitors: ExhibitorInfo[];
  company: Company | null;
  loading: boolean;
}

export default Vue.extend({
  name: 'admin-exhibitor-new',
  data(): DataType {
    return {
      exhibitors: [],
      company: null,
      loading: true,
      // account: {
      //   email: '',
      //   password: '',
      // },
    };
  },
  computed: {
    isNew(): boolean {
      return !this.$route.query.id;
    },
    owner(): string {
      return this.$route.query.id as string || v4();
    },
  },
  methods: {
    formatDateTime(dt: any) {
      return calender.formatDateTime(dt);
    },
    async onClickAdd() {
      console.log('onClickAdd');
      this.exhibitors.push({
        exhibitor: exhibitor.createNewExhibitor(),
        account: {
          email: '',
          password: '',
        },
      });
    },
    async onClick() {
      try {
        this.$loading(true);
        // this.loading = true;
        if (this.company) {
          const cid = this.company.id;
          // const now = firebase.now();

          const uids = [];
          for (const ex of this.exhibitors) {
            ex.exhibitor.data.cid = cid;
            ex.exhibitor.data.email = ex.account.email;

            if (!ex.exhibitor.id) {
              console.log('TUIKA');
              ex.exhibitor = await exhibitor.create(
                this.$auth.uid,
                ex.exhibitor,
                ex.account.email,
                ex.account.password,
              );
            } else {
              console.log('HENKO');
              ex.exhibitor = await exhibitor.save(
                this.$auth.uid,
                ex.exhibitor,
              );
            }
            if (!ex.exhibitor.id) {
              throw Error('Can not find ex id');
            }

            uids.push(ex.exhibitor.id);
          }

          // const uid = this.$auth.uid;
          // const auth = ret.data;
          // const uid = auth.uid;

          const now = new Date();
          if (!this.company.id) {
            this.company.id = cid;
            this.company.data.registeredDate = now;
            this.company.data.createdDt = now;
            this.company.data.createdBy = this.$auth.uid;
          }

          // this.company.data.owner = uid;
          this.company.data.members = uids;
          this.company = await company.save(this.$auth.uid, this.company);

          if (this.company.id) {
            this.$router.push({
              name: 'admin-admin-exhibitor-detail',
              params: {
                id: this.company.id,
              },
            });
          }
        }
        this.$success('保存しました。');
      } catch (error: any) {
        this.$error('保存に失敗しました。', error);
      } finally {
        this.$loading(false);
      }
    },
    async fetchData() {
      try {
        // const cid = this.$route.params.id;
        this.loading = true;
        if (this.isNew) {
          this.exhibitors.push({
            exhibitor: exhibitor.createNewExhibitor(),
            account: {
              email: '',
              password: '',
            },
          });
          this.company = company.createNewExhibitorCompany(this.owner);
        } else {
          this.company = await company.load(this.owner);

          const es = await exhibitor.loadsByCID(this.owner);
          const ls: ExhibitorInfo[] = [];
          for (const e of es) {
            ls.push({
              exhibitor: e,
              account: {
                email: e.data.email,
                password: 'xxxxxxxxxxxxxxx',
              },
            });
          }
          this.exhibitors = ls;
        }
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
      }
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    await this.fetchData();
  },
  async mounted() {
    // this.updateHeader(this.$route.fullPath);
    await this.fetchData();
  },

});
